"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyNumbersAndStar = exports.removeExtraSpacesBetweenWords = exports.joinArrays = void 0;
exports.onlyNumbers = onlyNumbers;
exports.onlyLetters = onlyLetters;
exports.onlyLettersAndSpace = onlyLettersAndSpace;
exports.onlyNumbersAndLetters = onlyNumbersAndLetters;
exports.onlyElasticSearchSafeChars = onlyElasticSearchSafeChars;
exports.onlyHex = onlyHex;
exports.removeDiatrict = removeDiatrict;
exports.sortObjectByAttr = sortObjectByAttr;
exports.mergeTextsStar = mergeTextsStar;
exports.mergeTexts = mergeTexts;
exports.mergeCodes = mergeCodes;
exports.mergeNumCodes = mergeNumCodes;
exports.parseDate = parseDate;
exports.formatIsoDateOnly = formatIsoDateOnly;
exports.textWithStar = textWithStar;
const date_fns_1 = __importDefault(require("./date-fns"));
const lodash_1 = __importDefault(require("./lodash"));
const fns = date_fns_1.default.singleton;
const lodash = lodash_1.default.singleton;
const joinArrays = (a, b, c) => {
    if (a && b && c) {
        return [...a, ...b, ...c];
    }
    if (a && b) {
        return [...a, ...b];
    }
    if (a)
        return a;
    if (b)
        return b;
    if (c)
        return c;
    return undefined;
};
exports.joinArrays = joinArrays;
exports.removeExtraSpacesBetweenWords = (() => {
    const splitBySpaces = /\s+/gm;
    return function removeExtraSpacesBetweenWords(str) {
        return str.replace(splitBySpaces, ' ');
    };
})();
function onlyNumbers(s, keepSignal = false) {
    if (!s) {
        return undefined;
    }
    const buffer = [];
    for (let i = 0; i < s.length; i++) {
        const ch = s.charAt(i);
        if (ch >= '0' && ch <= '9') {
            buffer.push(ch);
        }
    }
    const result = buffer.join('');
    if (!result) {
        return undefined;
    }
    if (keepSignal && s.indexOf('-') !== -1) {
        return `-${result}`;
    }
    return result;
}
function onlyLetters(s) {
    if (!s) {
        return undefined;
    }
    const buffer = [];
    for (let i = 0; i < s.length; i++) {
        const ch = s.charAt(i);
        if ((ch >= 'A' && ch <= 'Z') ||
            (ch >= 'a' && ch <= 'z') ||
            (ch > 'z' && ch.toLowerCase() !== ch.toUpperCase())) {
            buffer.push(ch);
        }
    }
    const result = buffer.join('');
    return result ? result : undefined;
}
function onlyLettersAndSpace(s) {
    if (!s) {
        return undefined;
    }
    const buffer = [];
    for (let i = 0; i < s.length; i++) {
        const ch = s.charAt(i);
        if (ch === ' ') {
            buffer.push(ch);
            continue;
        }
        if ((ch >= 'A' && ch <= 'Z') ||
            (ch >= 'a' && ch <= 'z') ||
            (ch > 'z' && ch.toLowerCase() !== ch.toUpperCase())) {
            buffer.push(ch);
            continue;
        }
    }
    const result = buffer.join('');
    return result ? result : undefined;
}
function onlyNumbersAndLetters(s) {
    if (!s) {
        return undefined;
    }
    const buffer = [];
    for (let i = 0; i < s.length; i++) {
        const ch = s.charAt(i);
        if ((ch >= '0' && ch <= '9') ||
            (ch >= 'A' && ch <= 'Z') ||
            (ch >= 'a' && ch <= 'z') ||
            (ch > 'z' && ch.toLowerCase() !== ch.toUpperCase())) {
            buffer.push(ch);
        }
    }
    const result = buffer.join('');
    return result ? result : undefined;
}
function onlyElasticSearchSafeChars(s) {
    if (!s) {
        return undefined;
    }
    const buffer = [];
    for (let i = 0; i < s.length; i++) {
        const ch = s.charAt(i);
        if (ch === '*' ||
            ch === ' ' ||
            (ch >= '0' && ch <= '9') ||
            (ch >= 'A' && ch <= 'Z') ||
            (ch >= 'a' && ch <= 'z') ||
            (ch > 'z' && ch.toLowerCase() !== ch.toUpperCase())) {
            buffer.push(ch);
        }
    }
    const result = buffer.join('');
    return result ? result : undefined;
}
const onlyNumbersAndStar = function (s) {
    if (!s) {
        return undefined;
    }
    const buffer = [];
    for (let i = 0; i < s.length; i++) {
        const ch = s.charAt(i);
        if ((ch >= '0' && ch <= '9') || ch === '*') {
            buffer.push(ch);
        }
    }
    const result = buffer.join('');
    return result ? result : undefined;
};
exports.onlyNumbersAndStar = onlyNumbersAndStar;
function onlyHex(s) {
    if (!s) {
        return undefined;
    }
    const buffer = [];
    for (let i = 0; i < s.length; i++) {
        const ch = s.charAt(i);
        if ((ch >= '0' && ch <= '9') || (ch >= 'A' && ch <= 'Z') || (ch >= 'a' && ch <= 'z')) {
            buffer.push(ch.toUpperCase());
        }
    }
    const result = buffer.join('');
    return result ? result : undefined;
}
function removeDiatrict(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function sortObjectByAttr(pickStr) {
    return (a, b) => {
        if (a === b)
            return 0;
        if (!a)
            return -1;
        if (!b)
            return 1;
        const sa = pickStr(a) ?? '';
        const sb = pickStr(b) ?? '';
        return String.prototype.localeCompare.call(sa, sb);
    };
}
function onlyWords(texts) {
    if (!texts) {
        return undefined;
    }
    const words = [];
    for (const text of texts) {
        if (!text) {
            continue;
        }
        const parts = text.split(/\s/g);
        for (const word of parts) {
            if (word) {
                words.push(word);
            }
        }
    }
    return words;
}
function mergeTextsStar(...arrays) {
    const r = mergeTexts(...arrays);
    if (r) {
        r.map((v) => `${v}*`);
    }
    return r;
}
function mergeTexts(...arrays) {
    if (arrays.length === 0) {
        return undefined;
    }
    const r = new Array();
    for (const entry of arrays) {
        if (!entry || entry.length === 0) {
            continue;
        }
        for (let subEntry of entry) {
            if (!subEntry || subEntry.length === 0) {
                continue;
            }
            subEntry = onlyElasticSearchSafeChars(subEntry) ?? '';
            if (!subEntry || subEntry.length === 0) {
                continue;
            }
            r.push(subEntry.toLocaleLowerCase());
        }
    }
    return r.length > 0 ? r : undefined;
}
function mergeCodes(...arrays) {
    if (arrays.length === 0) {
        return undefined;
    }
    const words = [];
    for (const entry of arrays) {
        if (!entry || entry.length === 0) {
            continue;
        }
        const wordArray = onlyWords(entry);
        wordArray && words.push(...wordArray);
    }
    const codes = [...new Set(words)];
    return codes.length > 0 ? codes : undefined;
}
function mergeNumCodes(...arrays) {
    const codes = mergeCodes(...arrays);
    if (!codes) {
        return undefined;
    }
    const numCodes = [];
    for (const codeVal of codes) {
        const numCode = onlyNumbers(codeVal);
        if (numCode) {
            numCodes.push(numCode);
        }
    }
    return numCodes.length > 0 ? numCodes : undefined;
}
function parseDate(value) {
    let dateValue;
    if (lodash().isNumber(value)) {
        dateValue = new Date(value);
    }
    else if (lodash().isString(value)) {
        dateValue = fns().parseISO(value);
    }
    return dateValue;
}
function formatIsoDateOnly(value) {
    const isoDate = fns().formatISO(value);
    return isoDate.length >= 10 ? isoDate.substring(0, 10) : undefined;
}
function textWithStar(text) {
    if (!text) {
        return undefined;
    }
    if ('*' === text) {
        return undefined;
    }
    if (text[text.length - 1] === '*') {
        return text;
    }
    return `${text}*`;
}
//# sourceMappingURL=utils.js.map